<!--
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-03-25 17:53:15
-->
<template>
  <van-action-sheet
    :show="localShow"
    :title="languages.i_feedback_verified_result"
    @close="close"
    @update:show="(val) => !val && close()"
  >
    <div class="custom-panel">
      <div class="questionaire-title">
        {{ languages.i_q1_result_accurate }}
      </div>
      <van-radio-group v-model="feedback">
        <van-radio name="i_q_accurate,1">{{
          languages.i_q_accurate
          /*i_q_accurate: 准确*/
        }}</van-radio>
        <van-radio name="i_q_no_fake,2">{{
          languages.i_q_no_fake /*i_q_no_fake: 不，我认为这张照片应该被验证为假照片。*/
        }}</van-radio>
        <van-radio name="i_q_no_authentic,3">{{
          languages.i_q_no_authentic
          /*i_q_no_authentic: 不，我认为这张照片应该被验证为真实的*/
        }}</van-radio>
        <van-radio name="i_q_not_sure,4">{{
          languages.i_q_not_sure
          /*i_q_not_sure: 我不确定*/
        }}</van-radio>
      </van-radio-group>
      <van-button type="primary" block :disabled="!feedback" @click="submit">
        {{
          languages.i_displayed_address_submit /*i_displayed_address_submit: 提交*/
        }}
      </van-button>
    </div>
  </van-action-sheet>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue'

const props = defineProps({
  show: Boolean,
  languages: Object
})

const emit = defineEmits(['close', 'submit'])

const feedback = ref('')
const localShow = ref(props.show)
const isClosing = ref(false)

watch(
  () => props.show,
  (newVal) => {
    localShow.value = newVal
  }
)

const close = () => {
  if (isClosing.value) return
  isClosing.value = true
  emit('close')
  feedback.value = ''
  setTimeout(() => {
    isClosing.value = false
  }, 300)
}

const submit = () => {
  emit('submit', feedback.value)
  close()
}
</script>

<style scoped>
.custom-panel {
  padding: 16px;
  font-size: 15px; /* 调整文本大小 */
}

.questionaire-title {
  margin-bottom: 20px;
  font-size: 17px;
}

.van-radio {
  margin-bottom: 25px; /* 调整单选按钮之间的间距 */
}

.van-button {
  margin-top: 30px; /* 调整按钮与单选按钮组之间的间距 */
  font-size: 17px; /* 调整按钮文本大小 */
}
</style>
